TweenMax.ticker.useRAF(true);
TweenMax.ticker.fps(60);

jQuery(document).ready(function($) {


	var mobileViewport = window.matchMedia("screen and (max-width: 767px)");

	if(mobileViewport.matches) {

		var d600 = 900;
		var d300 = 450;
		var d200 = 300;

	} else {

		var d600 = 900;
		var d300 = 450;
		var d200 = 300;

	}

	var scrollMagicController = new ScrollMagic.Controller({
		refreshInterval: 1,
	});
	var homeTop = new ScrollMagic.Scene({
		triggerElement: '.top',
	})
	.setClassToggle(".not-loaded", "loaded")
	.addTo(scrollMagicController);

	$('.services').find('.service-anim').each(function(index, item) {

		var element = $(this)[0];

		var tween = TweenMax.fromTo(element, d200 * ($(this).data('id') + 1), {
			opacity: 0,
			y: 30 * ($(this).data('id') + 1),
		}, {
			opacity: 1,
			y: 0,
			yoyo: true,
			ease: Linear.easeNone,
		});

		var scene = new ScrollMagic.Scene({
			triggerElement: element,
			triggerHook: 0.9,
			duration: d200,
		})
		.setTween(tween)
		.addTo(scrollMagicController);

		scene.refresh();

	});

	document.addEventListener('DOMContentLoaded', function () {
	if (window.innerWidth >= 991) {
		$('.section-header-anim').each(function() {

			var tween = TweenMax.fromTo($(this)[0], d300, {
				opacity: 0,
				y: 90,
			}, {
				opacity: 1,
				y: 0,
				yoyo: true,
				ease: Linear.easeNone,
			});

			var scene = new ScrollMagic.Scene({
				triggerElement: $(this)[0],
				triggerHook: 1,
				duration: d300,
			})
			.setTween(tween)
			.addTo(scrollMagicController);

			scene.refresh();

		});
		}
	})
	$('.services .button-anim').each(function() {

		var tween = TweenMax.fromTo($(this)[0], d300, {
			opacity: 0,
			y: 140,
		}, {
			opacity: 1,
			y: 0,
			yoyo: true,
			ease: Linear.easeNone,
		});

		var scene = new ScrollMagic.Scene({
			triggerElement: $(this)[0],
			triggerHook: 1,
			duration: d300,
		})
		.setTween(tween)
		.addTo(scrollMagicController);

		scene.refresh();

	});

	var fadeIn = TweenMax.fromTo('.testimonials', d300, {
		opacity: 0,
		y: 80,
	}, {
		opacity: 1,
		y: 0,
		yoyo: true,
		ease: Linear.easeNone,
	});

	var testimonials = new ScrollMagic.Scene({
		triggerElement: '.testimonials',
		triggerHook: 1,
		duration: d300,
	})
	.setTween(fadeIn)
	.addTo(scrollMagicController);

	var zoomIn = TweenMax.fromTo('.testimonial__thumb', d300, {
		opacity: 0,
		scale: 0,
	}, {
		opacity: 1,
		scale: 1,
		yoyo: true,
		ease: Linear.easeNone,
	});

	var testimonialThumb = new ScrollMagic.Scene({
		triggerElement: '.testimonial__thumb',
		triggerHook: 1,
		duration: d300,
	})
	.setTween(zoomIn)
	.addTo(scrollMagicController);

	var fadeLeft = TweenMax.fromTo('.testimonial__content', d300, {
		opacity: 0,
		x: -80,
	}, {
		opacity: 1,
		x: 0,
		yoyo: true,
		ease: Linear.easeNone,
	});

	var testimonialContent = new ScrollMagic.Scene({
		triggerElement: '.testimonial__thumb',
		triggerHook: 1,
		duration: d300,
	})
	.setTween(fadeLeft)
	.addTo(scrollMagicController);

	$('.points').find('.point-box').each(function(index, item) {

		var element = $(this)[0];

		var tween = TweenMax.fromTo(element, d200 * ($(this).data('id')) + 1, {
			opacity: 0,
			y: 30 * ($(this).data('id') + 1),
		}, {
			opacity: 1,
			y: 0,
			yoyo: true,
			ease: Linear.easeNone,
		});

		var scene = new ScrollMagic.Scene({
			triggerElement: element,
			triggerHook: 0.9,
			duration: d200,
		})
		.setTween(tween)
		.addTo(scrollMagicController);

		scene.refresh();

	});

	if(!mobileViewport.matches) {

		var aboutPhoto = TweenMax.fromTo('.about__pic-anim', d300, {
			opacity: 0,
			x: -80,
		}, {
			opacity: 1,
			x: 0,
			yoyo: true,
			ease: Linear.easeNone,
		});

		var aboutScene = new ScrollMagic.Scene({
			triggerElement: ".about__pic-anim",
			triggerHook: 1,
			duration: d300,
		})
		.setTween(aboutPhoto)
		.addTo(scrollMagicController);

		var aboutContent = TweenMax.fromTo('.about__content', d300, {
			opacity: 0,
			x: -80,
		}, {
			opacity: 1,
			x: 0,
			yoyo: true,
			ease: Linear.easeNone,
		});

		var aboutScene2 = new ScrollMagic.Scene({
			triggerElement: ".about__content",
			triggerHook: 1,
			duration: d300,
		})
		.setTween(aboutContent)
		.addTo(scrollMagicController);

		var extraTween = TweenMax.fromTo('.extra-anim', d600, {
			opacity: 0,
			y: -200,
		}, {
			opacity: 1,
			y: 0,
			yoyo: true,
			ease: Linear.easeNone,
		});

		var extraScene = new ScrollMagic.Scene({
			triggerElement: ".extra-anim",
			triggerHook: 1,
			duration: d600,
		})
		.setTween(extraTween)
		.addTo(scrollMagicController);

	}

	var contactTween = TweenMax.fromTo('.contact-anim', d200, {
		opacity: 0,
		x: -80,
	}, {
		opacity: 1,
		x: 0,
		yoyo: true,
		ease: Linear.easeNone,
	});

	var contactScene = new ScrollMagic.Scene({
		triggerElement: ".contact-anim",
		triggerHook: 1,
		duration: d200,
	})
	.setTween(contactTween)
	.addTo(scrollMagicController);

});



// WEBPACK FOOTER //
// ./wp-content/themes/revitallaser/js/animations.js